var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.5C8 13.2239 7.77614 13 7.5 13C7.22386 13 7 13.2239 7 13.5V15.5C7 15.7761 7.22386 16 7.5 16C7.77614 16 8 15.7761 8 15.5V13.5ZM10 9C10.2761 9 10.5 9.22386 10.5 9.5L10.5 15.5C10.5 15.7761 10.2761 16 10 16C9.72386 16 9.5 15.7761 9.5 15.5L9.5 9.5C9.5 9.22386 9.72386 9 10 9ZM13 11.5C13 11.2239 12.7761 11 12.5 11C12.2239 11 12 11.2239 12 11.5V15.5C12 15.7761 12.2239 16 12.5 16C12.7761 16 13 15.7761 13 15.5V11.5ZM4 4C4 2.89543 4.89543 2 6 2H10.5858C10.9836 2 11.3651 2.15804 11.6464 2.43934L15.5607 6.35355C15.842 6.63486 16 7.01639 16 7.41421V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V4ZM6 3C5.44772 3 5 3.44772 5 4V16C5 16.5523 5.44772 17 6 17H14C14.5523 17 15 16.5523 15 16V8H11.5C10.6716 8 10 7.32843 10 6.5V3H6ZM11.5 7H14.7929L11 3.20711V6.5C11 6.77614 11.2239 7 11.5 7Z",
    fill: "#262626"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.8d8d665941af56d868e089e9073f5000.svg";
export { ForwardRef as ReactComponent };